import { css } from '@emotion/react';

export const useStyles = () => ({
  root: css`
    display: flex;
    flex-direction: column;
  `,
});
